import * as Sentry from "@sentry/react";
import { analyticsAllowed } from "@/lib/cookie-consent";

const DSN =
  "https://14b059a9e4f0b190e0a3ad87b964a75f@o4511235471900672.ingest.de.sentry.io/4511235493462096";

let initialized = false;

function detectEnvironment(): "production" | "preview" {
  if (typeof window === "undefined") return "preview";
  const host = window.location.hostname;
  if (host === "relark.dk" || host === "www.relark.dk") {
    return "production";
  }
  return "preview";
}

export function initSentry(): void {
  if (initialized) return;
  // Skip in local dev to avoid noise + quota burn
  if (import.meta.env.DEV) return;
  if (!DSN) return;

  Sentry.init({
    dsn: DSN,
    environment: detectEnvironment(),
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // GDPR: only send events when the user has accepted analytics cookies.
    beforeSend(event) {
      if (!analyticsAllowed()) return null;
      return event;
    },
  });

  initialized = true;

  // If the user later revokes analytics consent, stop sending events.
  window.addEventListener("cookieConsentUpdated", () => {
    if (!analyticsAllowed() && initialized) {
      Sentry.close().catch(() => {
        /* ignore */
      });
      initialized = false;
    }
  });
}

export { Sentry };
